import React from 'react'
import PartnerGallery from '../components/PartnerGallery';
// import Card from '../components/Card'
// import { Link } from 'react-router-dom'

export default function PartnerWUs() {
  const serviceOfferings = [
    "Bookkeeping", "Payroll", "Tax Preparation", "Financial Reporting", "Consulting"
  ];
  const steps = [
    {
      title: "Client Name",
      key: "clientName",
      render: (value, onChange, enabled) => (
        <input type="text" className="input" placeholder="Enter client name" value={value} onChange={onChange} disabled={!enabled} />
      ),
      validate: v => !!v,
    },
    {
      title: "Client Address",
      key: "clientAddress",
      render: (value, onChange, enabled) => (
        <input type="text" className="input" placeholder="Enter address" value={value} onChange={onChange} disabled={!enabled} />
      ),
      validate: v => !!v,
    },
    {
      title: "Email Address",
      key: "email",
      render: (value, onChange, enabled) => (
        <input type="email" className="input" placeholder="Enter email" value={value} onChange={onChange} disabled={!enabled} />
      ),
      validate: v => !!v && /.+@.+\..+/.test(v),
    },
    {
      title: "Phone Number",
      key: "phone",
      render: (value, onChange, enabled) => (
        <input type="tel" className="input" placeholder="Enter phone number" value={value} onChange={onChange} disabled={!enabled} />
      ),
      validate: v => !!v,
    },
    {
      title: "Background/Experience",
      key: "background",
      render: (value, onChange, enabled) => (
        <textarea className="input" placeholder="Describe background/experience" value={value} onChange={onChange} disabled={!enabled} rows={3} />
      ),
      validate: v => !!v,
    },
    {
      title: "Service Offerings",
      key: "serviceOffering",
      render: (value, onChange, enabled) => (
        <select className="input" value={value} onChange={onChange} disabled={!enabled}>
          <option value="">Select...</option>
          {serviceOfferings.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      ),
      validate: v => !!v,
    },
    {
      title: "Certifications",
      key: "certifications",
      render: (value, onChange, enabled) => (
        <input type="text" className="input" placeholder="Enter certifications" value={value} onChange={onChange} disabled={!enabled} />
      ),
      validate: v => !!v,
    },
    {
      title: "LinkedIn",
      key: "linkedin",
      render: (value, onChange, enabled) => (
        <input type="url" className="input" placeholder="LinkedIn profile URL" value={value} onChange={onChange} disabled={!enabled} />
      ),
      validate: v => !!v,
    },
    {
      title: "Review and Approval",
      key: "review",
      render: (value, onChange, enabled, allValues) => (
        <div>
          <div style={{marginBottom:12}}>
            <strong>Review your information:</strong>
            <ul style={{marginTop:8, marginBottom:8}}>
              {Object.entries(allValues).filter(([k]) => k !== "review").map(([k, v]) => (
                <li key={k}><strong>{steps.find(s => s.key === k)?.title || k}:</strong> {v}</li>
              ))}
            </ul>
          </div>
          <button className="btn primary" onClick={onChange} disabled={!enabled}>Approve & Submit</button>
        </div>
      ),
      validate: v => v === true,
    },
  ];

  const [values, setValues] = React.useState({
    clientName: "",
    clientAddress: "",
    email: "",
    phone: "",
    background: "",
    serviceOffering: "",
    certifications: "",
    linkedin: "",
    review: false,
  });
  const [approved, setApproved] = React.useState(false);

  const completed = steps.map((step, idx) => {
    if (idx === 0) return step.validate(values[step.key]);
    return steps[idx - 1].validate(values[steps[idx - 1].key]) && step.validate(values[step.key]);
  });

  const handleChange = key => e => {
    let value;
    if (key === "review") {
      setValues(prev => ({ ...prev, review: true }));
      setApproved(true);
      return;
    }
    if (e && e.target) {
      value = e.target.value;
    } else {
      value = e;
    }
    setValues(prev => ({ ...prev, [key]: value }));
  };

  return (
    <div className="container">
      <PartnerGallery />
      <section className="card">
        <h2 className="h2">Partner With Us</h2>
        <div style={{ maxWidth: 500, margin: "2rem auto" }}>
          {steps.map((step, idx) => {
            const enabled = idx === 0 || completed[idx - 1];
            if (step.key === "review" && approved) {
              return (
                <div key={step.key} className="card" style={{ marginBottom: "1.5rem", padding: "1.5rem", background: '#e6ffe6', border: '1px solid #b2ffb2' }}>
                  <h3>Approved!</h3>
                  <p>Your submission has been approved. A tile will be created in Tab 4.</p>
                </div>
              );
            }
            return (
              <div key={step.key} className="card" style={{ marginBottom: "1.5rem", padding: "1.5rem", opacity: enabled ? 1 : 0.5 }}>
                <h3>{step.title}</h3>
                {step.render(values[step.key], handleChange(step.key), enabled, values)}
                {!enabled && <div style={{ color: '#888', fontSize: '0.9em', marginTop: '0.5em' }}>Complete previous step to enable</div>}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
